import { useLang } from "@/i18n/LanguageContext";

const LOGOS = [
  { src: "/clients/metart.png", alt: "Metart", h: "h-11" },
  { src: "/clients/ydl-stone.png", alt: "YDL Stone", h: "h-9" },
  { src: "/clients/bipo.png", alt: "BIPO", h: "h-16" },
  { src: "/clients/united-imaging.png", alt: "United Imaging", h: "h-9" },
  { src: "/clients/soneven.png", alt: "Soneven", h: "h-14" },
  { src: "/clients/lions-cellar.png", alt: "Lion's Cellar", h: "h-24" },
];

export default function ClientLogos() {
  const { t } = useLang();
  const track = [...LOGOS, ...LOGOS, ...LOGOS];
  return (
    <section data-testid="client-logos" className="bg-white border-y border-ink-900/8 py-10 sm:py-12 overflow-hidden">
      <div className="container-x">
        <p className="text-overline text-center mb-8">{t.clients.overline}</p>
      </div>
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 sm:w-40 bg-gradient-to-r from-white to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 sm:w-40 bg-gradient-to-l from-white to-transparent z-10" />
        <div className="marquee flex items-center gap-16 sm:gap-24 w-max">
          {track.map((l, i) => (
            <div key={i} className="flex items-center justify-center h-24 shrink-0" data-testid={i < LOGOS.length ? `client-logo-${i + 1}` : undefined}>
              <img
                src={l.src}
                alt={l.alt}
                className={`${l.h} w-auto max-w-[220px] object-contain grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-500`}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
